// ========================================
// ================== V3 ==================
// ========================================

import { put } from "redux-saga/effects";
import axios from "../../axios";
import * as actions from "../actions/index";
import * as kApi from "../../constants/api";
import { Auth } from "aws-amplify";
import { refreshTokenSaga } from "./_LocalRefreshToken";

export function* initFetchPlansSaga(action) {
  try {
    const response = yield axios.get(kApi.API_URL_PLANS, {
      headers: {
        Authorization: Auth.user.signInUserSession.idToken.jwtToken,
      },
    });

    yield put(actions.fetchPlansSuccess(response.data));
  } catch (error) {
    try {
      const refreshToken = yield refreshTokenSaga();
      const response = yield axios.get(kApi.API_URL_PLANS, {
        headers: {
          Authorization: refreshToken.signInUserSession.idToken.jwtToken,
        },
      });

      yield put(actions.fetchPlansSuccess(response.data));
    } catch (error) {
      yield put(actions.fetchPlansFail(error));
    }
  }
}
